import {
    GAdvice,
    GDyForm,
    GExamination,
    GFollowUp,
    GLabTest,
    GMedication,
    GPTemplate,
    GRefer,
    GSymptomsDiagnosis,
    GTreatmentPackage,
    GTreatmentService,
    GVitals,
    SectionNameConfig,
} from '../store/db';
import { GET_MY_GENIE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import {
    CalculatorsConfig,
    ExtraFlags,
    GenieSettings,
    MedicalHistoryConfig,
    VitalsConfig,
} from './pushGenie';
import { PrintConfig, Translate } from './pushVisit';

export interface GenieProfile {
    id: string;
    advices?: GAdvice[];
    diagnosis?: GSymptomsDiagnosis[];
    labTests?: GLabTest[];
    medications?: GMedication[];
    symptoms?: GSymptomsDiagnosis[];
    vitals?: GVitals[];
    templates?: GPTemplate[];
    examinations?: GExamination[];
    printConfig?: PrintConfig;
    followUp: GFollowUp[];
    refer?: GRefer[];
    forms?: FormData;
    settings?: GenieSettings;
    translate?: Translate;
    padDForms?: GDyForm[];
    medicalHistoryConfig?: MedicalHistoryConfig;
    vitalsConfig?: VitalsConfig;
    calculatorConfig?: CalculatorsConfig;
    sectionNameConfig?: SectionNameConfig;
    version?: number;
    extraFlags: ExtraFlags;
    treatmentServices?: GTreatmentService[];
    treatmentPackages?: GTreatmentPackage[];
    treatmentServicesAndTreatmentPackages?: TreatmentServicesAndTreatmentPackages;
    roles?: Role[];
    dicom?: Dicom;
    ipd?: Ipd;
}

export interface Role {
    _id: string;
    id: string;
    name: string;
    owner_oid: string;
    persona: string;
    policies: Policy[];
    is_active: boolean;
    archive: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface Policy {
    action: string;
    subject: string;
}

export interface TreatmentServicesAndTreatmentPackages {
    enabled: boolean;
    treatment_services_fetched_at?: string;
}

export interface Dicom {
    enabled: boolean;
}

export interface Ipd {
    enabled: boolean;
}

export interface PtDir {
    userLevel: boolean;
    disableAllPtFetch?: boolean;
    enableBEGlobalSearch?: boolean;
}

export interface BizSettings {
    summaryPdfLocalDisabled: boolean;
    searchAndAddPatient: boolean;
    fixPdfIconEnabled: boolean;
    showPurchaseEkaCreditsPopover: boolean;
    localPrintDisabled: boolean;
    showNewSignInStrip: boolean;
}

export interface ReferralConfig {
    withinBusiness: boolean;
    mobileOptional: boolean;
}

export interface FormData {
    addp?: DFormEntity[] | null;
}
export interface DFormEntity {
    label: string;
    type: 'string' | 'number' | 'select';
    key: string;
}

export interface MyGinieProfileResponse {
    success: string;
    error?: string;
    data?: GenieProfile[];
}

export default (
    docids?: string[],
    from?: string,
    treatmentServicesAndTreatmentPackagesEnabled?: boolean,
    roles?: string[],
): Promise<MyGinieProfileResponse> =>
    fetchWithRefresh(
        GET_MY_GENIE(docids, from, treatmentServicesAndTreatmentPackagesEnabled, roles),
    ).then((res) => res.json());
